export const mentaojiConfig = {
  propList: [
    {
      prop: 'serial_num',
      label: 'cuttingDock.knives.number',
      minWidth: 50,
      slotName: 'serial_num',
    },
    {
      prop: 'saw_width',
      label: 'cuttingDock.knives.sawDiameter',
      minWidth: 100,
      slotName: 'saw_width',
      interactionType: 'textarea',
    },
    {
      prop: 'saw_direction',
      label: 'cuttingDock.knives.sawType',
      minWidth: 120,
      slotName: 'saw_direction',
    },
    {
      prop: 'cut_from',
      label: 'cuttingDock.knives.cutDirection',
      minWidth: 150,
      slotName: 'cut_from',
    },
    // 'X偏移'
    {
      label: 'cuttingDock.drillSettings.toolTable.xOffset',
      prop: 'x_offset',
      slotName: 'x_offset',
      minWidth: 150,
      interactionType: 'textarea',
    },
    // Y偏移
    {
      label: 'cuttingDock.drillSettings.toolTable.yOffset',
      prop: 'y_offset',
      slotName: 'y_offset',
      minWidth: 150,
      interactionType: 'textarea',
    },
    {
      prop: 'move_speed',
      label: 'cuttingDock.knives.moveSpeed',
      minWidth: 100,
      slotName: 'move_speed',
      interactionType: 'textarea',
    },
    {
      prop: 'cut_speed',
      label: 'cuttingDock.knives.cutSpeed',
      minWidth: 100,
      slotName: 'cut_speed',
      interactionType: 'textarea',
    },
    {
      prop: 'start_code',
      label: 'cuttingDock.knives.startCode',
      minWidth: 120,
      slotName: 'start_code',
      interactionType: 'textarea',
    },
    {
      prop: 'end_code',
      label: 'cuttingDock.knives.endCode',
      minWidth: 120,
      slotName: 'end_code',
      interactionType: 'textarea',
    },
    {
      prop: 'saw_down_code',
      label: 'cuttingDock.knives.sawDownCode',
      minWidth: 100,
      slotName: 'saw_down_code',
      interactionType: 'textarea',
    },
    {
      prop: 'saw_up_code',
      label: 'cuttingDock.knives.sawUpCode',
      minWidth: 100,
      slotName: 'saw_up_code',
      interactionType: 'textarea',
    },
    {
      prop: 'abscissa',
      label: 'cuttingDock.knives.abscissa',
      minWidth: 100,
      slotName: 'abscissa',
      interactionType: 'textarea',
    },
    {
      prop: 'ordinate',
      label: 'cuttingDock.knives.ordinate',
      minWidth: 100,
      slotName: 'ordinate',
      interactionType: 'textarea',
    },
  ],
  showIndexColumn: false,
}

// 生成随机的 elementID
export const knifeStoreConfigList = [
  // 编号
  {
    label: 'cuttingDock.knives.number',
    props: 'desc',
    width: 70,
    isCheck: false,
    elementId: 'span_0b3vlz24gt',
  },
  // 名称
  {
    label: 'cuttingDock.knives.name',
    props: 'name',
    width: 90,
    isCheck: false,
    elementId: 'span_c9rs0lm29f',
  },
  // 刀直径
  {
    label: 'cuttingDock.knives.diameter',
    props: 'diameter',
    width: 90,
    isCheck: false,
    elementId: 'span_a3nyvbohcd',
  },
  // 类型
  {
    label: 'cuttingDock.knives.type',
    props: 'type',
    width: 120,
    isCheck: false,
    elementId: 'span_msmg073i34',
  },
  // 开料
  {
    label: 'cuttingDock.knives.cutting',
    props: 'cutable',
    width: 70,
    isCheck: false,
    elementId: 'span_2vef6tytal',
  },
  // 用途
  {
    label: 'cuttingDock.knives.use',
    props: 'use',
    width: 140,
    isCheck: false,
    elementId: 'span_p0seoo3o0t',
  },
  {
    label: 'cuttingDock.knives.axis_offset',
    props: 'axis_offset',
    width: 140,
    isCheck: true,
    elementId: 'span_l39rt3ri3c',
  },
  {
    label: 'cuttingDock.knives.arc_radius',
    props: 'arc_radius',
    width: 140,
    isCheck: true,
    elementId: 'span_t43jq1w2m4',
  },
  // Z轴快速移动速度
  {
    label: 'cuttingDock.knives.moveZF',
    props: 'moveZF',
    width: 130,
    // 速度类：支持英文/空格/换行，见 handleInputCheck
    isCheck: false,
    elementId: 'span_bpmau51gg8',
  },
  // Z轴加工速度
  {
    label: 'cuttingDock.knives.cutZF',
    props: 'cutZF',
    width: 140,
    isCheck: false,
    elementId: 'span_ne9gukquil',
  },
  // XY轴快速移动速度
  {
    label: 'cuttingDock.knives.moveF',
    props: 'moveF',
    width: 140,
    isCheck: false,
    elementId: 'span_2r0j6xe9f0',
  },
  // XY轴加工速度
  {
    label: 'cuttingDock.knives.cutF',
    props: 'cutF',
    width: 140,
    isCheck: false,
    elementId: 'span_w0lh9i6bio',
  },
  // 换刀开始代码
  {
    label: 'cuttingDock.knives.startCode',
    props: 'startCode',
    width: 140,
    isCheck: false,
    elementId: 'span_h46r22wz1q',
  },
  // 换刀结束代码
  {
    label: 'cuttingDock.knives.stopCode',
    props: 'stopCode',
    width: 140,
    isCheck: false,
    elementId: 'span_y1hz00tmwf',
  },
  // 刀长度
  {
    label: 'cuttingDock.knives.knifeLength',
    props: 'length',
    width: 140,
    isCheck: true,
    elementId: 'span_r5agghnpft',
  },
  // 单次最大加工深度
  {
    label: 'cuttingDock.knives.maximum_single_depth',
    props: 'maximum_single_depth',
    width: 140,
    isCheck: true,
    elementId: 'span_51wyzoykjg',
  },
]
// 激光一体机反面刀库
export const backKnifeStoreConfigList = [
  // 编号
  {
    label: 'cuttingDock.knives.number',
    props: 'desc',
    width: 70,
    isCheck: false,
  },
  // 名称
  {
    label: 'cuttingDock.knives.name',
    props: 'name',
    width: 90,
    isCheck: false,
  },
  // 刀直径
  {
    label: 'cuttingDock.knives.diameter',
    props: 'diameter',
    width: 90,
    isCheck: false,
  },
  // 类型
  {
    label: 'cuttingDock.knives.type',
    props: 'type',
    width: 120,
    isCheck: false,
  },
  // 开料
  {
    label: 'cuttingDock.knives.cutting',
    props: 'cutable',
    width: 70,
    isCheck: false,
  },
  // 用途
  {
    label: 'cuttingDock.knives.use',
    props: 'use',
    width: 140,
    isCheck: false,
  },
  // Z轴快速移动速度
  {
    label: 'cuttingDock.knives.moveZF',
    props: 'moveZF',
    isCheck: true,
  },
  // Z轴加工速度
  {
    label: 'cuttingDock.knives.cutZF',
    props: 'cutZF',
    isCheck: true,
  },
  // XY轴快速移动速度
  {
    label: 'cuttingDock.knives.moveF',
    props: 'moveF',
    isCheck: true,
  },
  // XY轴加工速度
  {
    label: 'cuttingDock.knives.cutF',
    props: 'cutF',
    isCheck: true,
  },
  // 换刀开始代码
  {
    label: 'cuttingDock.knives.startCode',
    props: 'startCode',
    isCheck: false,
  },
  // 换刀结束代码
  {
    label: 'cuttingDock.knives.stopCode',
    props: 'stopCode',
    isCheck: false,
  },
]

export const gangDrillTableConfigList = [
  // 钻头直径
  { label: 'cuttingDock.drillSettings.toolTable.diameter', prop: 'diameter' },
  // 'X偏移'
  { label: 'cuttingDock.drillSettings.toolTable.xOffset', prop: 'xOffset' },
  // Y偏移
  { label: 'cuttingDock.drillSettings.toolTable.yOffset', prop: 'yOffset' },
  // Z轴快速移动速度
  { label: 'cuttingDock.drillSettings.toolTable.moveZF', prop: 'moveZF' },
  // Z轴加工速度
  { label: 'cuttingDock.drillSettings.toolTable.feedRate', prop: 'feedRate' },
  // XY轴快速移动速度
  { label: 'cuttingDock.drillSettings.toolTable.moveF', prop: 'moveF' },
]
